<template>
<div>
  <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Setting  /  Form</h5></vs-button>
    </vs-row>
  <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Form</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
<vs-card style="border-radius: 20px;">
  <b-modal id="modal-xl" size="xl" title="View Form"  scrollable ><vs-card v-if="view">
    <FormRenderer
      :form-configuration="formData"
      v-model="formInputData"/>
      <br><br>
      <vs-row vs-justify="center">
        <h5>Sign Here</h5>
      </vs-row><br>
      <vs-row vs-justify="center">
      <VueSignaturePad width="500px" height="300px" ref="signaturePad"
        style="border-style: solid;
        border-size: 1px;" />
      </vs-row><br>
      
  </vs-card>
  <template #modal-footer="{ cancel}">
      
      <b-button size="sm" variant="danger" @click="cancel()">
        Cancel
      </b-button>
     
    </template>
    </b-modal>
  <div slot="header" >
        <vs-row class="mt-2" id="center">
        <h3 id="p" style="color: #111111">
            Form
          </h3>
          <h3 id="v" style="color: #111111">
            Form
          </h3>
        <vs-spacer />
         <vs-tooltip text="Print" position="top" >
        <vs-button radius   color="#333f50" type="line"   icon="print"></vs-button></vs-tooltip>&nbsp;&nbsp;
        <vs-tooltip text="Download a PDF" position="top" >
          <vs-button radius  color="#333f50" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>&nbsp;&nbsp;
          <vs-tooltip text="Export" position="top" >
          <vs-button radius  color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>&nbsp;&nbsp;
           <vs-tooltip  text="Create Form Template" position="left" >
          <vs-button   radius @click="show = true" color="#333f50" type="line"  icon="add"></vs-button></vs-tooltip>&nbsp;&nbsp;
        <!-- <vs-button color="#007bff" type="line" icon="add" @click="show = true">Create Form Template</vs-button><br> -->
       
        </vs-row>
      </div>



    <vs-table :data="worklist" search style="background-color: #F2F3F4 ;">
        <template slot="header" >
          <h5 >&nbsp;&nbsp;
            Form Template List
          </h5>
        </template>
        <template slot="thead">
          <vs-th sort-key="name"><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>Name
          </vs-th>
          <vs-th><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>Binding WOs
          </vs-th>
          <vs-th><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>Detail
          </vs-th>
          <vs-th><span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>Form Type
          </vs-th>
          <vs-th>
          </vs-th>
         
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td :data="data[indextr].name">
              {{data[indextr].conf.formConfig.headline}}
            </vs-td>
            <vs-td :data="data[indextr].wo">
              null
            </vs-td>
            <vs-td :data="data[indextr].detail">
              {{data[indextr].conf.formConfig.subHeadline}}
            </vs-td>
            <vs-td :data="data[indextr].type">
              {{data[indextr].type}}
            </vs-td>
            
            <vs-td :data="data[indextr].id">
              
              <vs-button v-b-modal.modal-xl class=" mr-2 " color="primary" type="flat" icon="visibility" @click="showform(data[indextr])">View</vs-button>
              <vs-button class="text-warning mr-2 " color="warning" type="flat" icon="create" @click="editform(data[indextr])">Edit</vs-button>
              <vs-button class="text-dark mr-2 " color="dark" type="flat" icon="content_copy" :disabled="true">Copy</vs-button>
              <vs-button class="text-danger mr-2 " color="danger" type="flat" icon="delete" v-b-modal.modal-center @click="btndelform=data[indextr]" >Delete</vs-button>
              
                    
            </vs-td>
          </vs-tr>
        </template>
      </vs-table><br>

      <b-modal id="modal-center" centered >
    <template #modal-title>
      <b class="text-danger"> <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete Form</b> 
    </template>
    <p class="my-4">Do you want to delete form?</p>
    
     <template #modal-footer="{ cancel }">
     
    
      <!-- Button with custom close trigger value -->
      <b-button id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
      <vs-button  color="danger" style="border-radius: 20px;" size="sm" @click="formDelete()" type="filled">Delete</vs-button>
    </template>
    
  </b-modal>
  
  <vs-card v-if="show">
    <h4 style="color: red">
    <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{type}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in typelist" :key="item" @click="actionchange(item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown><span v-if="type == 'Work Type Select'">***Dont forget to Select Type</span>
    </h4><br><br>
    <FormBuilder v-model="configuration" v-if="show"></FormBuilder>
  <vs-button @click="save" class="ml-4" v-if="show">Save</vs-button>
  <vs-button @click="close" v-if="show" class="ml-4">Close</vs-button>
  </vs-card>
  
  
</vs-card></div>
</template>

<script>
  import {FormBuilder,FormRenderer} from 'v-form-builder';
  export default {
    name: "Form",
    components: {
      FormRenderer,
      FormBuilder
    },
    data: () => ({
      type: 'Work Type Select',
      typelist: ['Work Order','Work Request','PM'],
      configuration: {},
      show: false,
      view: false,
      btndelform: '',
      worklist: [],
      formData: null,
      formInputData: null,
      acceptConfirm: false,
      item: null,
      id: null
    }),
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    savesig() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      // console.log(isEmpty);
      // console.log(data);
    },
    log() {
      // console.log(this.configuration)
    },
    showform(item) {
      // // console.log(item)
      this.formData = item.conf
      this.view = true
    },
    editform(item) {
      this.id = item.id
      this.configuration = item.conf
      this.show = true
      if(item.type == 'Not Selected') {
        this.type = 'Work Type Select'
      }else this.type = item.type
    },
    actionchange(item) {
      this.type = item
    },
    close() {
      this.type = 'Work Type Select'
      this.id = null
      this.show = false
      this.configuration = null
    },
    save() {
      if(this.type == 'Work Type Select') {
        this.type = "Not Selected"
      }
      this.$http.post(this.$url+'saveform', {
        headers: {
          'Access-Control-Request-Method': '*',
          'Access-Control-Request-Headers': '*',
          'Origin': '*'
        },
        conf: this.configuration,
        username: this.$session.get('username'),
        type: this.type,
        id: this.id || null
      }).then(() => {
        this.$vs.notify({
          title: "Save Complete",
          text: "Complete!",
          color: "success",
          position: "top-center",
          icon: 'check',
        })
        setTimeout(()=>{
          location.reload()
        },300);
      })
    },
    del(item) {
      this.item = item
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: 'Confirm Delete Form?',
        accept: this.formDelete
      })
    },
    formDelete() {
      this.$http.post(this.$url+'updateform', {
        headers: {
          'Access-Control-Request-Method': '*',
          'Access-Control-Request-Headers': '*',
          'Origin': '*'
        },
        id: this.btndelform.id,
        isDelete: true
      }).then(() => {
        location.reload()
      })
    }
  },
  mounted() {
    this.$http.get(this.$url+'getform/'+this.$session.get('token'))
    .then((result) => {
      // console.log(result.data)
      this.worklist = result.data
    })
  }
}
</script>

<style scoped>
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>
<style>
input {
  border-radius: 5px;
}

button {
  border-radius: 5px;
}
.btn.btn-primary {
  border-radius: 5px;
}
.btn.btn-secondary {
  border-radius: 5px;
}
.btn.btn-warning {
  border-radius: 5px;
}
.btn.btn-danger {
  border-radius: 5px;
}
.btn.btn-info {
  border-radius: 5px;
}
.list-group-item.list-group-item-action {
  border-radius: 5px;
}
.form-control {
  border-radius: 1%;
}
p.copyright-text{
  display:none;
}
th {
  padding: 0px; 
}
.col-md-4.control-view-wrapper {
  padding-left: 1%;
}
 button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
    border-radius: 5px;
  }
  th .sort-th .th-sort-icon {
    color: white;
    padding: 0px;
  }
  #p {
  display: inline;
}
#v {
  display: none;
}
#center{
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) { 
  .a{
     /* background: pink; */
     width: 200px;
   }
   #v {
  display: inline;
}
#p {
  display: none;
}
   .vuesax-app-is-ltr .vs-table--search-input{
     width: 100px;
     padding: o;
   }
   .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
} 
        }
</style>